import { sameIdSets } from './id-set-filter';

export function isAllOrganisationsSelected(
  selectedIds: number[],
  allIds: number[],
): boolean {
  return allIds.length > 0 && sameIdSets(selectedIds, allIds);
}

export function isNoOrganisationSelected(selectedIds: number[]): boolean {
  return selectedIds.length === 0;
}

export function getEffectiveOrganisationSelectedIds(
  selectedIds: number[],
): Set<number> {
  return new Set(selectedIds);
}

export function toggleOrganisationInSelection(
  selectedIds: number[],
  toggledId: number,
): number[] {
  if (selectedIds.includes(toggledId)) {
    return selectedIds.filter((id) => id !== toggledId);
  }

  return [...selectedIds, toggledId];
}
